export default "__VITE_ASSET__QzHuaUAQ__"